import {
    GetInvitationDetailsParams,
    GetInvitationDetailsResponse,
} from '@/types/invitation';
import {
    AcceptInvitationParams,
    CancelInvitationParams,
    DismissInvitationParams,
    OpenInvitationParams,
    OpenInvitationResponse,
    OpenInvitationV2Response,
    RemoveMemberParams,
    UpdateInvitationStatusParams,
} from '@/types/organisations';

import apiClient from './apiClient';

async function removeMember(params: RemoveMemberParams) {
    const { data } = await apiClient.v2.post(
        '/invitations/remove_member',
        params,
    );

    return data;
}

async function openInvitationV1(params: OpenInvitationParams) {
    const { data } = await apiClient.v1.post<OpenInvitationResponse>(
        '/invitations/open',
        params,
    );

    return data;
}

async function openInvitationV2(params: OpenInvitationParams) {
    const { data } = await apiClient.v2.post<OpenInvitationV2Response>(
        '/invitations/open',
        params,
    );

    return data;
}

async function updateOwnerInvitationStatus(
    params: UpdateInvitationStatusParams,
) {
    const { data } = await apiClient.v1.post(
        '/invitations/update_status_owner',
        params,
    );
    return data;
}

async function updateUserInvitationStatus(
    params: UpdateInvitationStatusParams,
) {
    const { data } = await apiClient.v1.post(
        '/invitations/update_status_user',
        params,
    );
    return data;
}

async function getInvitationDetails(params: GetInvitationDetailsParams) {
    const { data } = await apiClient.v2.get<GetInvitationDetailsResponse>(
        `/invitations/${params.invitationId}/organisation_details`,
    );

    return data;
}

async function dismissInvitation(params: DismissInvitationParams) {
    const { data } = await apiClient.v1.post('/invitations/dismiss', params);

    return data;
}

async function cancelInvitation(params: CancelInvitationParams) {
    const { data } = await apiClient.v2.post('/invitations/cancel', params);

    return data;
}

async function acceptInvitation(params: AcceptInvitationParams) {
    const { data } = await apiClient.v2.post('/invitations/accept', params);

    return data;
}

export const OrganisationsInvitationsAPI = {
    removeMember,
    updateOwnerInvitationStatus,
    updateUserInvitationStatus,
    getInvitationDetails,
    dismissInvitation,
    openInvitationV1,
    openInvitationV2,
    cancelInvitation,
    acceptInvitation,
};
